import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';
import swal from 'sweetalert2';
import { incidencia } from 'src/app/shared/model/incidencias/saveIncidence.model';
import { EtapaProyectoBean } from 'src/app/shared/model/incidencias/etapaproyecto.model';
import { Incidencias } from 'src/app/shared/model/incidencias/incidencia.model';
import { IncidenciasService } from '../incidencias.service';
import { VersionBean } from 'src/app/shared/model/incidencias/version.model';
import { EvidenciaBean } from 'src/app/shared/model/incidencias/evidenciaBean.model';
import { incidenciaDetalleQABean } from 'src/app/shared/model/incidencias/incidenciaDetalleQABean.model';
import { MensajesFijosEnum } from 'src/app/utilerias/enums/mensajes-fijos-enum';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import {
  idVigente,
  OpcionVersion,
  opcionesDeVersion,
  opcionesSinEstado,
  rechazoDelGuardado,
} from '../resolucion-version.util';

@Component({
  selector: 'app-alta-incidencia',
  standalone: true,
  templateUrl: './alta-incidencia.component.html',
  styleUrls: ['./alta-incidencia.component.css'],
  imports: [
    NgIf,
    NgFor,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatListModule,
  ],
})
export class AltaIncidenciaComponent implements OnInit {
  incimodel: incidencia = new incidencia();
  data: FormGroup;
  open = 'ABIERTO';

  evidencia: File[] = [];
  selectedOptions: File[] = [];
  index: number;
  btnElimina = true;
  btnAgrega = false;
  totalsize = 0;

  listaprioridad: any;
  beanversion = new EtapaProyectoBean();
  listaversion: Array<VersionBean> = [];
  /** Las versiones de la etapa para elegir la detectada: de la más nueva a la más vieja, con la vigente elegida. */
  opcionesVersion: OpcionVersion[] = [];
  version = new VersionBean();
  formRegistro: FormGroup;
  beanIncidenciaQA = new Incidencias();
  evidencias = new EvidenciaBean();
  incidenciaDetalleQA = new incidenciaDetalleQABean();
  listaTipo: any;
  proyectoNombre = '';
  etapaNombre = '';
  isClientePortal = false;

  constructor(
    private incidenciasService: IncidenciasService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {}

  ngOnInit() {
    const state = history.state;
    const proyecto = state?.proyecto;
    const idEtapa = state?.idEtapa;
    this.isClientePortal = state?.origenCliente === true;

    if (!proyecto || !idEtapa) {
      this.regresar();
      return;
    }

    this.beanversion.id_proyecto_etapa = proyecto.id;
    this.beanversion.id_etapa = idEtapa;
    this.proyectoNombre = proyecto.nombre ?? '';

    const etapaSeleccionada = proyecto.etapas?.find((etapa) => etapa.id === idEtapa);
    this.etapaNombre = etapaSeleccionada?.nombre ?? '';
    this.listaversion = etapaSeleccionada?.versiones || [];
    // Plan de etapas y versiones §8: «· Vigente / · Cerrada» y la vigente
    // elegida. El portal de clientes sigue con su lista como estaba.
    this.opcionesVersion = this.isClientePortal
      ? opcionesSinEstado(etapaSeleccionada?.versiones)
      : opcionesDeVersion(etapaSeleccionada?.versiones);

    this.formreg();
    if (!this.isClientePortal) {
      this.formRegistro.get('version')?.setValue(idVigente(this.opcionesVersion) ?? '');
    }
    this.ngConsultaPrioridad();
    this.ngConsultaTipo();
  }

  ngConsultaPrioridad() {
    this.incidenciasService.consultaPrioridad().subscribe((res) => {
      this.listaprioridad = res;
    });
  }

  ngConsultaTipo() {
    this.incidenciasService.consultaTipo().subscribe((tp) => {
      this.listaTipo = tp;
    });
  }

  onSave() {
    if (!this.formRegistro.valid) {
      swal.fire({
        text: MensajesFijosEnum.INCIDENCIA_DATOS_VACIOS,
        buttonsStyling: false,
        customClass: {
          confirmButton: 'btn btn-danger',
        },
        icon: 'error',
      });
      return;
    }

    this.beanIncidenciaQA.titulo = this.formRegistro.value.titulo;
    this.beanIncidenciaQA.descincidencia = this.formRegistro.value.descripcion;
    this.beanIncidenciaQA.estatus = this.open;
    this.beanIncidenciaQA.prioridad = this.formRegistro.value.prioridad;
    this.beanIncidenciaQA.id_proyecto = this.beanversion.id_proyecto_etapa;
    this.beanIncidenciaQA.id_etapa = this.beanversion.id_etapa;
    this.beanIncidenciaQA.version = this.formRegistro.value.version;
    this.beanIncidenciaQA.tipo = this.formRegistro.value.tipo;

    const guardar$ = this.isClientePortal
      ? this.incidenciasService.guardarIncidenciaCliente(this.beanIncidenciaQA)
      : this.incidenciasService.guardaIncidencia(this.beanIncidenciaQA);

    guardar$.subscribe((incidenciaGuardada) => {
      // Un rechazo (VAL-INC-VERSION: la versión no es de la etapa) o una
      // respuesta vacía no se pintan como éxito ni suben evidencia.
      const rechazo = rechazoDelGuardado(incidenciaGuardada);
      if (rechazo) {
        swal.fire({
          text: rechazo,
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-danger',
          },
          icon: 'error',
        });
        return;
      }
      if (this.evidencia.length > 0) {
        const formData = new FormData();
        const tipoEvidencia = this.isClientePortal ? 'INCIDENCIACLIENTE' : 'INCIDENCIA';
        const ambiente = this.isClientePortal ? 'CLIENTE' : 'QA';
        for (let i = 0; i < this.evidencia.length; i++) {
          formData.append(
            'file',
            this.evidencia[i],
            tipoEvidencia +
              '$' +
              ambiente +
              '$' +
              incidenciaGuardada.id +
              '$' +
              incidenciaGuardada.detalleBean.id +
              '$' +
              incidenciaGuardada.id_proyecto +
              '$' +
              this.evidencia[i].name
          );
        }
        this.incidenciasService.uploadEvidencia(formData).subscribe();
      }

      swal
        .fire({
          text: MensajesFijosEnum.INCIDENCIA_EXITOSA,
          buttonsStyling: false,
          customClass: {
            confirmButton: 'btn btn-success',
          },
          icon: 'success',
        })
        .then(() => {
          this.regresar();
        });
    });
  }

  formreg() {
    this.formRegistro = this.formBuilder.group({
      titulo: ['', [Validators.required]],
      prioridad: ['', [Validators.required]],
      version: ['', [Validators.required]],
      tipo: ['', [Validators.required]],
      estatus: this.open,
      descripcion: ['', [Validators.required]],
    });
  }

  subirEv() {
    const input = document.getElementById('nameFile') as HTMLInputElement | null;
    if (!input?.files?.length) {
      return;
    }

    for (let i = 0; i < input.files.length; i++) {
      const file = input.files.item(i);
      if (!file) {
        continue;
      }
      this.totalsize += file.size;
      this.evidencia.push(file);
    }
    input.value = '';
  }

  onNgModelChange(event: File[]) {
    this.selectedOptions = event;
    this.btnElimina = this.selectedOptions.length === 0;
    this.btnAgrega = this.selectedOptions.length !== 0;
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex((item) => item.name === this.selectedOptions[i].name);
      if (this.index >= 0) {
        this.evidencia.splice(this.index, 1);
      }
    }

    const input = document.getElementById('nameFile') as HTMLInputElement | null;
    if (input) {
      input.value = '';
    }

    this.selectedOptions = [];
    this.btnElimina = true;
    this.btnAgrega = false;
  }

  onNoClick(): void {
    this.regresar();
  }

  onCloseClick() {
    this.regresar();
  }

  regresar() {
    this.router.navigate([this.isClientePortal ? '/CLIENTE/incidencias' : '/INCIDENCIAS/INC_QA']);
  }
}
